export const SET_FETCHING = 'countryPicker/SET_FETCHING';
export const SET_COUNTRIES = 'countryPicker/SET_DESTINATIONS';
export const RESET_STATE = 'countryPicker/RESET_STATE';
